module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Sketch-a69a6a57ddd29d26049f7379924fed78.svg";